import storage from "redux-persist/lib/storage";
import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import sitesReducer from "./features/sites/sites-slice";
import companiesReducer from "./features/companies/companies-slice";
import companyReducer from "./features/company/company-slice";
import usersReducer from "./features/users/users-slice";
import userReducer from "./features/user/user-slice";
import dashboardReducer from "./features/dashboard/dashboard-slice";
import siteReducer from "./features/site/site-slice";
import productsReducer from "./features/products/products-slice";
import campaignsReducer from "./features/campaigns/campaigns-slice";
import boostingReducer from "./features/campaigns/boosting-slice";
import categoriesReducer from "./features/categories/categories-slice";
import panelReducer from "./features/panel/panel-slice";
import feedReducer from "./features/feed/feed-slice";
import pagesReducer from "./features/pages/pages-slice";
import uiReducer from "./features/ui/ui-slice";
import assetsReducer from "./features/assets/assets-slice";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["companies", "user"],
};

const persisted = combineReducers({
  companies: companiesReducer,
  company: companyReducer,
  dashboard: dashboardReducer,
  site: siteReducer,
  sites: sitesReducer,
  products: productsReducer,
  campaigns: campaignsReducer,
  boosting: boostingReducer,
  user: userReducer,
  users: usersReducer,
  categories: categoriesReducer,
  panel: panelReducer,
  feed: feedReducer,
  pages: pagesReducer,
  ui: uiReducer,
  assets: assetsReducer,
});

const rootReducer = (
  state: ReturnType<typeof persisted> | undefined,
  action: AnyAction,
) => {
  if (action.type === "user/signOut" || action.type === "panel/resetStorage") {
    storage.removeItem("persist:root");
    return persisted(undefined, action);
  }
  return persisted(state, action);
};

const reducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
